import { Injectable } from '@angular/core';

export abstract class TranslateCompiler {
  abstract compile(value: string, lang: string): string | Function;
  abstract compileTranslations(translations: any, lang: string): any;
}

@Injectable()
export class TranslateFakeCompiler extends TranslateCompiler {
  compile(value: string, _lang: string): string | Function {
    return value;
  }

  compileTranslations(translations: any, _lang: string): any {
    return translations;
  }
}
